export interface ITreeInformation {
  selectedKey: number;
  expandKeys(): number[];
}

export function instanceOfITreeInformation(instance: any): instance is ITreeInformation {
  return instance
    && (instance.selectedKey !== undefined)
    && (instance.expandKeys !== undefined);
}
